import { render, staticRenderFns } from "./AddAmassadorComponent.vue?vue&type=template&id=aaff3b5e"
import script from "./AddAmassadorComponent.vue?vue&type=script&lang=js"
export * from "./AddAmassadorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports